"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectContactData.name': 'Wykrywanie Danych Kontaktowych',
    'tools.detectContactData.description': 'Automatycznie wykrywa i wyodrębnia informacje kontaktowe, takie jak numery telefonów, e-maile, adresy i nazwiska z wiadomości użytkowników',
};
